import FeaturedInLogos from 'Images/FeaturedInLogos.png'
import GenericLazyLoadImage from 'components/generic/GenericLazyLoadImage'
import { CenteringDiv, FlexRowDiv, P } from 'components/generic/HomePageComponents'

const AsFeaturedIn = () => (
  <FlexRowDiv>
    <CenteringDiv>
      <P fontWeight='400' fontSize='18px' lineHeight='1.429' borderBottom='1px #ccc solid'>
        As Featured In
      </P>
      <GenericLazyLoadImage
        title='CareGuide media logos'
        alt='CareGuide media logos'
        width={{ _: '300px', desktop: '1000px' }}
        src={FeaturedInLogos}
        mb='50px'
      />
    </CenteringDiv>
  </FlexRowDiv>
)

export default AsFeaturedIn
